module.exports = __webpack_public_path__ + "static/media/Coaching.b3539da2.webp";